import { Util } from '@grandvisionhq/forms'

const { isValidPostalCodeForCountry } = Util.validations

export const eircodeValidator = (value: string) => {
  return isValidPostalCodeForCountry('IE', value)
}

export const isPhoneNumber = (value: string): boolean => {
  return REGEX.PHONE_NUMBER.test(value)
}

export const isMobilePhoneNumber = (value: string): boolean => {
  return REGEX.MOBILE_PHONE_NUMBER.test(value)
}

export const isValidBirthDate = (value: string): boolean => {
  const [year, month, day] = value.split('-')
  if (!year || !month || !day) {
    return false
  }

  return Util.validations.isValidBirthDate(year, month, day)
}

/**
 * Check the validity of an Irish "Personal Public Service number".
 */
export const isPPSN = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false
  }
  value = value.replace(REGEX.WHITESPACE, '').toUpperCase()
  if (!REGEX.PPSN.test(value)) {
    return false
  }
  let sum = 0
  for (let i = 0; i < 7; i++) {
    const checkedValue = value[i]
    if (checkedValue !== undefined) {
      sum += (8 - i) * parseInt(checkedValue, 0)
    }
  }
  if (value[8] && value[8] !== 'W') {
    sum += 9 * (value.charCodeAt(8) - 64)
  }
  return sum % 23 === value.charCodeAt(7) - 64
}

const REGEX = {
  PHONE_NUMBER: /^\d{10,13}$/,
  MOBILE_PHONE_NUMBER: /^08\d{8}$/,
  PPSN: /^\d{7}[A-Z]{1,2}$/,
  WHITESPACE: /\s/g,
}
